export default "__VITE_ASSET__B3FG_qeH__"